module.exports = __webpack_public_path__ + "img/logo-forbes.4ec27708.png";